import pushGTMEvent from '@helpers/analyticsHelpers/pushGTMEvent';

type Actions =
  | 'delivery_widget_opened'
  | 'delivery_widget_opened_after_add_to_cart'
  | 'delivery_widget_opened_after_cart'
  | 'toggled_to_click_and_collect'
  | 'toggled_to_home_delivery';

type DeliveryMethodLabel = 'click_and_collect_shown' | 'home_delivery_shown' | '';

const trackDeliveryPicker = (action: Actions, label: DeliveryMethodLabel) => {
  pushGTMEvent({
    event: 'Track',
    category: 'delivery_widget',
    action,
    label,
    value: 0,
  });
};

const trackDeliveryPickerToggle = (
  action: 'toggled_to_click_and_collect' | 'toggled_to_home_delivery',
  category: 'delivery_widget' | 'checkout_delivery_options'
) => {
  pushGTMEvent({
    event: 'Track',
    category,
    action,
    label: '',
    value: 0,
  });
};

export { trackDeliveryPicker, trackDeliveryPickerToggle };
